import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b5ebfbc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=4b5ebfbc&prod&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=4b5ebfbc&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ebfbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTabs: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/header-tabs/index.vue').default,VideoTagWarp: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/video-swiper/components/video-tag-warp.vue').default,VideoAction: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/video-swiper/components/video-action.vue').default,VideoInfo: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/video-swiper/components/video-info.vue').default,NewOpenKwaiNotice: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/new-open-kwai-notice/index.vue').default})
